import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export const SubscriptionPaymentFailed = () => {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen w-full flex items-center justify-center"
      style={{
        background:
          "radial-gradient(ellipse at center, #dde0ff 0%, #eef1ff 60%, #f4f5ff 100%)",
      }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.88, y: 30 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.45, ease: "easeOut" }}
        className="relative bg-white rounded-3xl shadow-2xl p-10 max-w-sm w-full text-center overflow-hidden"
      >
        {/* X circle */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{
            delay: 0.2,
            type: "spring",
            stiffness: 260,
            damping: 18,
          }}
          className="mx-auto mb-6 w-20 h-20 rounded-full bg-[#FF4D4D] flex items-center justify-center relative z-10"
          style={{ boxShadow: "0 8px 32px rgba(255,77,77,0.4)" }}
        >
          <svg
            className="w-10 h-10 text-white"
            fill="none"
            stroke="currentColor"
            strokeWidth={3}
            viewBox="0 0 24 24"
          >
            <motion.path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6"
              initial={{ pathLength: 0 }}
              animate={{ pathLength: 1 }}
              transition={{ delay: 0.3, duration: 0.3, ease: "easeOut" }}
            />
            <motion.path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 6l12 12"
              initial={{ pathLength: 0 }}
              animate={{ pathLength: 1 }}
              transition={{ delay: 0.45, duration: 0.3, ease: "easeOut" }}
            />
          </svg>
        </motion.div>

        {/* Title */}
        <h2 className="text-xl font-bold text-gray-900 mb-2 relative z-10">
          Payment Failed 😞
        </h2>

        {/* Description */}
        <p className="text-gray-500 text-sm leading-relaxed mb-8 relative z-10">
          Something went wrong and your payment could not be processed. Please
          try again or use a different payment method.
        </p>

        {/* Buttons */}
        <div className="flex flex-col gap-3 relative z-10">
          <motion.button
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            onClick={() => navigate("/")}
            className="w-full py-3 rounded-xl bg-[#EDEEF2] hover:bg-[#e0e1ea] text-gray-600 font-medium text-sm transition"
          >
            Go to Homepage
          </motion.button>
        </div>
      </motion.div>
    </div>
  );
};
